import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/chart/:prefectureId/:diff?',
    name: 'chart',
    component: () => import('../views/Chart.vue'),
    beforeEnter: (to, from, next) => {
      document.title = "Covid19チャート";
      next();
    }
  },
  {
    path: '/',
    name: 'list',
    component: () => import('../views/List.vue'),
    beforeEnter: (to, from, next) => {
      document.title = "Covid19チャート（全都道府県）";
      next();
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
export default router
